export default __webpack_public_path__ + "static/media/icon-erm-sp.b6a06f7e.svg";